"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldToolbarButton = void 0;
const react_1 = __importDefault(require("react"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const table_field_styles_1 = require("./table-field-styles");
const tooltip_1 = require("../tooltip/tooltip");
function TableFieldToolbarButton({ show, title, onClick, IconComponent, disabled, children, component = 'button', color = 'primary', variant = 'text', href, }) {
    const classes = table_field_styles_1.useStyles();
    if (show && children) {
        return (react_1.default.createElement(Button_1.default, { component: component, onClick: onClick, disabled: disabled, href: href, color: color, variant: variant, size: "small", className: classes.button },
            react_1.default.createElement(tooltip_1.Tooltip, Object.assign({}, { title, placement: 'top' }),
                react_1.default.createElement("div", { className: classes.iconButtonIcon },
                    react_1.default.createElement(IconComponent, { color: disabled ? 'disabled' : 'inherit' }),
                    children))));
    }
    else if (show) {
        return (react_1.default.createElement(IconButton_1.default, { component: component, onClick: onClick, classes: { root: classes.iconButton }, disabled: disabled, href: href, color: color },
            react_1.default.createElement(tooltip_1.Tooltip, Object.assign({}, { title, placement: 'top' }),
                react_1.default.createElement(IconComponent, { color: disabled ? 'disabled' : 'inherit' }))));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
exports.TableFieldToolbarButton = TableFieldToolbarButton;
//# sourceMappingURL=table-field-toolbar-button.js.map